import { render, staticRenderFns } from "./AlertInfo.vue?vue&type=template&id=4a56dbe8&scoped=true&"
import script from "./AlertInfo.vue?vue&type=script&lang=js&"
export * from "./AlertInfo.vue?vue&type=script&lang=js&"
import style0 from "./AlertInfo.vue?vue&type=style&index=0&id=4a56dbe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a56dbe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a56dbe8')) {
      api.createRecord('4a56dbe8', component.options)
    } else {
      api.reload('4a56dbe8', component.options)
    }
    module.hot.accept("./AlertInfo.vue?vue&type=template&id=4a56dbe8&scoped=true&", function () {
      api.rerender('4a56dbe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/AlertInfo.vue"
export default component.exports